import React, { Fragment } from 'react';
//import ReactGA from 'react-ga';
import classNames from "classnames"
import { withRouter } from 'react-router';
import Cookies from 'universal-cookie';

import Emitter from 'core/services.js';
import Labels from '../variables/labels.js';

import {
  getCompletedServices, getInProgressServices, getScheduleServices, getScheduleHistoryServices,
  getShowcaseWorkDetails, getShowcaseWorkDetailsCal, provideServiceFeedback, confirmGoogleReview, getCompletedPendingPayment
} from '../api/routes/api.route.js';
import Loader from '../components/loader/loader';
import CardService from '../components/card/service/serviceCard.jsx';
import Grid from 'components/list/grid/grid.jsx';
import Modal, { Information, Confirmation } from 'components/modal/modal.jsx';
import Helper from '../core/helper/helper';
import { HelperSchedule } from './schedule/core/helpers/helperSchedule.js';
import { Helmet } from 'react-helmet';
import { getItemList, postLogLite } from '../api/routes/api.route.js';
import LocalData from '../core/localData.js';
import ConfirmationCTA from '../components/button/ConfirmationCTA.jsx';
import ScheduleService from './schedule/core/services/schedule.service.js';
// Import Swipe
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Scrollbar } from 'swiper/core';
// Import Swiper styles
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/components/scrollbar/scrollbar.scss'; // Scrollbar styles
import BVService from '../core/services/services-view.service.js';
import { analyseUrlShowcaseAnalytics } from '../core/services/analytics.service.js';
import VideoTutorial from '../components/modal/samples/videoTutorial.jsx';
import { GENERAL, SIDEBAR } from '../assets/images/images.js';
import IAgreeBox from '../components/iagree/iagreeBox.jsx';
import CompanyService from '../core/services/company.service.js';
import Button from '../components/button/button.jsx';

// Enable the Scrollbar module
SwiperCore.use([Scrollbar]);

class Home extends React.Component {

  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this._isMounted = false;
    this.timer = null;
    this.refModal = React.createRef();
    this.listviewRef = React.createRef();
    const query = this.props.location.search;
    this.token = new URLSearchParams(query).get('token') || LocalData.liteData?.token;
    this.token_cal = new URLSearchParams(query).get('token_cal') || LocalData.liteData?.token_cal;
    this.isLiteVersion = Helper.isLiteVersion();
    this.isLiteWithoutToken = this.isLiteVersion && !this.token && !this.token_cal;

    this.state = {
      scheduleWorks: undefined,
      scheduleHistoryWorks: undefined,
      progressWorks: null,
      completedWorks: undefined,
      historyWorksSorted: [],
      pendingPaymentWorks: [],
      progressWorksState: false,
      scheduleWorksState: false,
      scheduleHistoryWorksState: false,
      completedWorksState: false,
      // scrollPosition: {
      //   scheduleScrollPos: ServicesViewService.scheduleScrollPos,
      //   progressScrollPos: ServicesViewService.progressScrollPos,
      //   completedScrollPos: ServicesViewService.completedScrollPos,
      // },
      listScrollPosition: sessionStorage.getItem('listScrollPosition'),
      toggled: false,
      showcaseWork: null,
      worksLoadError: {
        progress: false,
        schedule: false,
        scheduleHistory: false,
        completed: false,
      },
      loadingState: {
        progress: true,
        schedule: true,
        scheduleHistory: true,
        completed: true
      },
      isLoading: true,
      swiperLoaded: BVService.swiperLoaded,
      firstTimeSwiperLoading: true,
      currentSlide: 0,
      isMobile: false,
      dataVersion: 0,
    };
    this.baseState = { ...this.state };
    this.lastServicesSignature = this.getServicesSignature(this.state);
    this.goToFeedback = new URLSearchParams(this.props.location.search).has('feedback');
  }

  getServicesSignature = (state = this.state) => {
    const stableStringify = (value) => {
      const seen = new WeakSet();

      const normalize = (input) => {
        if (input === null || typeof input !== 'object') {
          return input;
        }

        if (seen.has(input)) {
          return null;
        }

        seen.add(input);

        if (Array.isArray(input)) {
          return input.map(normalize);
        }

        return Object.keys(input)
          .sort()
          .reduce((accumulator, key) => {
            const normalizedValue = normalize(input[key]);
            if (normalizedValue !== undefined) {
              accumulator[key] = normalizedValue;
            }
            return accumulator;
          }, {});
      };

      return JSON.stringify(normalize(value));
    };

    return stableStringify({
      showcaseWork: state.showcaseWork,
      progressWorks: state.progressWorks,
      pendingPaymentWorks: state.pendingPaymentWorks,
      scheduleWorks: state.scheduleWorks,
      scheduleHistoryWorks: state.scheduleHistoryWorks,
      completedWorks: state.completedWorks,
    });
  }

  // Helper to merge and sort history works and appointments
  mergeAndSortHistoryWorks = (completedWorks, scheduleHistoryWorks) => {
    const allWorks = [...(completedWorks || []), ...(scheduleHistoryWorks || [])];
    // Separate works with no date_end and no date_start
    const noDateWorks = allWorks.filter(w => !w.date_end && !w.date_start);
    const datedWorks = allWorks.filter(w => w.date_end || w.date_start);
    const ptMonths = {
      'jan': 0, 'fev': 1, 'mar': 2, 'abr': 3, 'mai': 4, 'jun': 5,
      'jul': 6, 'ago': 7, 'set': 8, 'out': 9, 'nov': 10, 'dez': 11
    };
    function parsePtDate(str) {
      if (!str) return new Date(0);
      str = str.replace(/\./g, '');
      str = str.replace(/\u00A0/g, ' ').replace(/\s+/g, ' ');
      str = str.trim().toLowerCase();
      if (str === 'hoje') {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
      }
      const parts = str.split(' ');
      if (parts.length < 2) return new Date(0);
      let day = parts[0];
      let month = parts[1];
      let year = parts[2];
      if (day === 'hoje' || month === 'hoje') {
        const now = new Date();
        day = now.getDate();
        month = Object.keys(ptMonths)[now.getMonth()];
        year = now.getFullYear();
      } else {
        if (!year) {
          year = String(new Date().getFullYear());
        }
      }
      const m = ptMonths[month.toLowerCase()];
      if (m === undefined) return new Date(0);
      return new Date(Number(year), m, Number(day));
    }
    // Sort dated works by date_end if exists, otherwise by date_start, descending
    const sortedDatedWorks = datedWorks.slice().sort((a, b) => {
      const dateA = parsePtDate(a.date_end || a.date_start);
      const dateB = parsePtDate(b.date_end || b.date_start);
      return dateB - dateA;
    });
    // Push cards with neither date_end nor date_start to the beginning
    return [...noDateWorks, ...sortedDatedWorks];
  }

  componentDidMount() {
    this._isMounted = true;
    this.mountButtonScrollPosition();
    this.handleResize();
    if (this.isLiteVersion) { this.mountLiteVersionData(); }
    if (!this.isLiteVersion && LocalData.terms_accepted) {
      this.cookies.remove('liteToken', Helper.cookiesLiteConfig);
      this.cookies.remove('liteEmail', Helper.cookiesLiteConfig);
      this.cookies.remove('litePhone', Helper.cookiesLiteConfig);
      this.cookies.remove('userId', Helper.cookiesLiteConfig);
      this.cookies.remove('isCalToken', Helper.cookiesLiteConfig);
      this.cookies.remove('kssreturncompany', Helper.cookiesLiteConfig);
      this.getServices();
    }
    this.refreshPage();

    if (Helper.isIOSWebview()) {
      try {
        window.webkit.messageHandlers.saveLastUrl.postMessage( {url: window.location.href} );
      } catch (error) {
        console.error(error);
      }
    }
    if (Helper.isAndroidWebview()) {
      try {
        window.Android.saveLastUrl(window.location.href);
      } catch (error) {
        console.error(error);
      }
    }

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('scroll', this.listenToScroll);
    this.listElement.removeEventListener('scroll', this.listenToListScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // When history or completed data loads asynchronously, ensure Swiper recalculates height
    const historyChanged = this.state.historyWorksSorted !== prevState.historyWorksSorted;
    const completedChanged = this.state.completedWorks !== prevState.completedWorks;
    const scheduleChanged = this.state.scheduleWorks !== prevState.scheduleWorks;
    const progressChanged = this.state.progressWorks !== prevState.progressWorks;
    const pendingPaymentChanged = this.state.pendingPaymentWorks !== prevState.pendingPaymentWorks;

    if (this.state.isMobile && this.swiperInstance && (historyChanged || completedChanged || scheduleChanged || progressChanged || pendingPaymentChanged)) {
      // Slight delay to allow DOM to paint before measuring
      setTimeout(() => {
        try {
          this.swiperInstance.update && this.swiperInstance.update();
          this.swiperInstance.updateAutoHeight && this.swiperInstance.updateAutoHeight(0);
          if (this.swiperInstance.scrollbar && this.swiperInstance.scrollbar.updateSize) {
            this.swiperInstance.scrollbar.updateSize();
          }
        } catch (e) {
          // no-op
        }
      }, 0);
    }

    const currentServicesSignature = this.getServicesSignature();
    if (this._skipSignatureCheck) {
      this._skipSignatureCheck = false;
      this.lastServicesSignature = currentServicesSignature;
    } else if (currentServicesSignature !== this.lastServicesSignature) {
      this.lastServicesSignature = currentServicesSignature;
      this.setState((prevState) => ({
        dataVersion: prevState.dataVersion + 1,
      }));
    }
  }


  handleResize = () => {
    const toastElem = document.querySelector(".Toastify__toast-container--top-right");
    if (toastElem && window.innerWidth <= 992) {
      toastElem.style.top = "108px";
    }
    this.setState({ isMobile: window.innerWidth <= 992 });
  };

  refreshPage = () => {
    if (!this.isLiteWithoutToken) {
      setTimeout(() => {
        if (this.isLiteVersion) { this.mountLiteVersionData(); }
        if (!this.isLiteVersion && LocalData.terms_accepted) {
          this.getServices();
          this.getUserItems();
          CompanyService.getCompaniesCount();
        }
        this.listenToScroll();
        this.refreshPage(); // Reschedule after processing the current check's result
      }, 300000);
    }
  }

  resetForm = () => {
    this.setState({...this.baseState})
  }

  mountLiteVersionData() {
    if (this.token) {
      this.cookies.set('liteToken', this.token, Helper.cookiesLiteConfig);
      if (this.email) { this.cookies.set('liteEmail', this.email, Helper.cookiesLiteConfig); }
      if (this.phone) { this.cookies.set('litePhone', this.phone, Helper.cookiesLiteConfig); }
      const companyDomain = Helper.companyDomain();
      if (!companyDomain.includes("asuaempresa")) {
        this.cookies.set('kssreturncompany', companyDomain, Helper.cookiesLiteConfig);
      }
      this.cookies.remove('isCalToken', Helper.cookiesLiteConfig);
    }
    if (this.token_cal) {
      this.cookies.set('liteToken', this.token_cal, Helper.cookiesLiteConfig);
      if (this.email) { this.cookies.set('liteEmail', this.email, Helper.cookiesLiteConfig); }
      if (this.phone) { this.cookies.set('litePhone', this.phone, Helper.cookiesLiteConfig); }
      const companyDomain = Helper.companyDomain();
      if (!companyDomain.includes("asuaempresa")) {
        this.cookies.set('kssreturncompany', companyDomain, Helper.cookiesLiteConfig);
      }

      this.cookies.set('isCalToken', true, Helper.cookiesLiteConfig); //in calendar context
    }
    if (LocalData.liteData) {
      const bars = LocalData.liteData.state.bars;
      this.setState({
        showcaseWork: LocalData.liteData,
        progressWorksState: bars > 0 && bars < 5,
        scheduleWorksState: bars === 0 && LocalData.liteData.is_history === false,
        completedWorksState: bars === 5 || (bars === 0 && LocalData.liteData.is_history === true),
        isLoading: false,
      });
    } else {
      if(this.token) {this.getShowcaseDetails(this.token, Helper.getSessionToken());}
      if(this.token_cal) {this.getShowcaseDetailsCal(this.token_cal, Helper.getSessionToken());}
    }
    if (this.isLiteWithoutToken) {
      this.setState({ isLoading: false });
    }
    if (this.timer) { clearTimeout(this.timer); }
  }

  mountButtonScrollPosition() {
    const { listScrollPosition } = this.state
    this._isMounted = true;
    this.listElement = document.getElementById('scroll-container');
    this.mobileElement = window.document.documentElement;

    if (window.innerWidth <= 992) {
      switch (BVService.swiperSlide) {
        case 0:
          this.scrollTo(BVService.progressScrollPos);
          break;
        case 1:
          this.scrollTo(BVService.scheduleScrollPos);
          break;
        case 2:
          this.scrollTo(BVService.completedScrollPos);
          break;
        default:
          break;
      }
    }
    window.addEventListener("scroll", this.listenToScroll);
    setTimeout(() => {
      if (listScrollPosition) {
        this.scrollListToTop(listScrollPosition);
      }
      this.listElement.addEventListener("scroll", this.listenToListScroll);
    }, 500);
  }

  scrollTo(pos) {
    setTimeout(() => {
      this.mobileElement.scrollTo(0, pos);
    }, 10);
  }

  scrollListToTop(pos) {
    this.listElement.scrollTo(0, pos);
  }

  listenToScroll = () => {
    const scrollTop = this.mobileElement.scrollTop;
    if (scrollTop || scrollTop === 0) {
      sessionStorage.removeItem('listScrollPosition');
      BVService.setScrollPosition(scrollTop);

      this.winScroll = scrollTop;
      BVService.setSwiperClasses(this.winScroll);

      const shouldToggle = this.listScroll >= 200;
      if (this.state.toggled !== shouldToggle) {
        this.setState({ toggled: shouldToggle });
      }
    }
  }

  listenToListScroll = () => {
    this.listScroll = this.listElement.scrollTop;
    if (this.listScroll && !this.state.isMobile) {
      sessionStorage.setItem('listScrollPosition', this.listScroll);
      sessionStorage.removeItem('scrollPosition');
      if (this.listScroll >= 200) {
        this.setState({ toggled: true });
      } else {
        this.setState({ toggled: false });
      }
    }
  }

  sendLog = (content) => {
    const body = { content };
    postLogLite(body);
  }

  /**
  * Pedido para retornar a obra a mostrar em caso de versão Lite
  *
  * @param {string} id - id para a obra
  */
  getShowcaseDetails(id, token) {
    this.sendLog(window.location.href);
    getShowcaseWorkDetails(id, token).then(value => {
      if (value) {
        if (value?.code === 1 && value?.details) {
          const { item } = value.details;
          const parsedWork = {
            ...value.details,
            item: {
              ...item,
              image: Helper.x64Image(item?.image),
            },
          };
          LocalData.liteData = parsedWork;
          if (value.details.user_id) {
            this.cookies.set("userId", value.details.user_id, Helper.cookiesLiteConfig);
          }
          if (value.details.email) {
            this.cookies.set("liteEmail", value.details.email, Helper.cookiesLiteConfig);
          }
          if (value.details.phone) {
            this.cookies.set("litePhone", value.details.phone, Helper.cookiesLiteConfig);
          }
          setTimeout(() => {
            this.props.history.push({
              pathname: "service-details-lite",
              search: new URLSearchParams(window.location.search).toString(),
            });
          }, 100);
        } else if (value?.code === 400 && value?.error_code === 0) {
          this.renderInfoModal("", value.message);
          this.setState({ isLoading: false });
        } else if (value?.code === 3 || value?.code === 2) {
          Emitter.emit('TOAST_LITEVERSION_DISABLE', true);
          this.renderModal(
            <Information
              title="Deseja aceder ao histórico da sua última intervenção?"
              text={Labels.liteGenericMessage(LocalData.configData?.is_scheduler_solo)}
              confirmText={Helper.getLiteRegisterButton()}
              onClick={() => {
                Helper.callLogError('getShowcaseDetails ServicesView');
                Helper.logoutFromLite();
              }}
            />
          );
          this.setState({ isLoading: false });
        } else if (value?.code === 5) {
          this.setState({ isLoading: false });
          if (this.goToFeedback) {
            analyseUrlShowcaseAnalytics(window.location.href, true, value.work_id); //Send analytics before redirect
            window.location.href = `${process.env.PUBLIC_URL}/service-details/${value?.work_id}?s=I&t=0&feedback=t`;
          } else {
            analyseUrlShowcaseAnalytics(window.location.href, true, value.work_id);
            window.location.href = `${process.env.PUBLIC_URL}/service-details/${value?.work_id}?s=I&t=0`;
          }
        } else {
          this.setState({ isLoading: false });
          this.renderGenericError();
        }
      }
      else {
        this.setState({ isLoading: false });
        this.renderGenericError();
      }
    });
  }

/**
  * Pedido para retornar o agendamento a mostrar em caso de versão Lite
  *
  * @param {string} id - id para a obra
  */
  getShowcaseDetailsCal(id, token) {
    this.sendLog(window.location.href);
    getShowcaseWorkDetailsCal(id, token).then(value => {
      if (value) {
        if (value?.code === 1 && value?.details) {   //Estava value===1. Martelado para testar
          const { item, date_start, date_end } = value.details;
          const formattedDateStart = date_start ? ScheduleService.convertDateFromISOPendingAppointment(date_start) : null;
          const formattedDateEnd = date_end
            ? ScheduleService.convertDateFromISOPendingAppointment(date_end)
            : null;
          const formattedTime = date_start ? ScheduleService.getTimeFromISO(date_start) : null;
          const formattedEndTime = date_end ? ScheduleService.getTimeFromISO(date_end) : null;
          const formattedCalendarShareDateStart = date_start ? ScheduleService.convertDateFromISOCalendarShare(date_start) : null;
          const formattedCalendarShareDateEnd = date_end ? ScheduleService.convertDateFromISOCalendarShare(date_end) : null;
          const { token, ...detailsWithoutToken } = value.details;
          const parsedWork = {
            ...detailsWithoutToken,
            date_start: formattedDateStart,
            date_end: formattedDateEnd,
            time: formattedTime,
            time_end: formattedEndTime,
            state: {name: HelperSchedule.getAppointmentStateBarsDescription(value.details), bars:0},
            shareCalendar_start_time: formattedCalendarShareDateStart,
            shareCalendar_end_time: formattedCalendarShareDateEnd,
            item: {
              ...item,
              image: Helper.x64Image(item?.photo)
            },
            token_cal: token
          };
          LocalData.liteData = parsedWork;
          if (value.details.user_id) {
            this.cookies.set('userId', value.details.user_id, Helper.cookiesLiteConfig);
          }
          if (value.details.email) {
            this.cookies.set('liteEmail', value.details.email, Helper.cookiesLiteConfig);
          }
          if (value.details.phone) {
            this.cookies.set('litePhone', value.details.phone, Helper.cookiesLiteConfig);
          }
          setTimeout(() => {
            this.props.history.push({
              pathname: 'service-details-lite',
              search: new URLSearchParams(window.location.search).toString(),
            });
          }, 100);
        } else if (value?.code === 400 && value?.error_code === 0) {
          this.renderInfoModal('', value.message);
          this.setState({ isLoading: false });
        } else if (value?.code===1 && !value.details) {
          Emitter.emit('TOAST_LITEVERSION_DISABLE', true);
          this.setState({ isLoading: false });

          if (Helper.getSessionToken()) {
            this.renderModal(
              <Information
                title="A marcação não está disponível ao cliente"
                text={""}
                confirmText={"Voltar à minha conta"}
                onClick={() => (window.location.href = `${process.env.PUBLIC_URL}`)}
              />
            );
          } else {
            this.renderModal(
              <Information
                title="A marcação não está disponível ao cliente"
                text={""}
                confirmText={"Fechar"}
                onClick={() => {
                  this.refModal.current.closeModal()
                  this.props.history.push("/services-lite");
                  }
                }
              />
            );
          }
        } else if (value?.code === 5) {
          this.setState({ isLoading: false });
          analyseUrlShowcaseAnalytics(window.location.href, true, value.work_id); //Send analytics before redirect
          window.location.href = `${process.env.PUBLIC_URL}/service-details/${value?.work_id}?s=I&t=0`;
        } else {
          this.setState({ isLoading: false });
          window.location.href = `${process.env.PUBLIC_URL}`;
        }
      }
      else {
        this.setState({ isLoading: false });
        this.renderGenericError();
      }
    });
    this.setState({ isLoading: false });
  }

  /**
   * Pedido para retornar dos os seriços que foram agendados
   *
   * @param {number} id - id do serviço
   * @param {string} feedback - objecto com o feedback (rating, observação)
   */
  sendServiceFeedback = (id, feedback) => {
    return provideServiceFeedback(Helper.getSessionToken(), id, feedback).then(value => {
      if (value) {
        if (value.code) {
          this.renderModal(<Information
            title="Pedido Sem Sucesso"
            text={value.message}
            onClick={() => {
              this.getServices();
              this.refModal.current.closeModal();
            }}
          />);
        } else {
            this.updateWorkFeedbackInPlace(id, feedback);
            CompanyService.getCompaniesCount();
            this.promptGoogleReview(value, () => {});
        }
      } else {
        this.renderModal(<Information
          title="Pedido Sem Sucesso"
          text={'Foi encontrado um problema durante o pedido, por favor tente mais tarde'}
          onClick={() => { this.refModal.current.closeModal(); }}
        />
        );
      }
    });
  }

  /**
   * Shows a merged "Feedback Enviado" + Google review prompt if applicable.
   * @returns {boolean} true if Google prompt was shown, false otherwise
   */
  promptGoogleReview = (response, onDismiss) => {
    if (response.google_review_url && response.google_review_stars >= 4) {
      const isFirst = response.is_first_google_review !== false;
      this.renderModal(
        <Confirmation
          title={response.message || 'Feedback Enviado'}
          text={isFirst ? "Pontuar também no Google?" : "A sua avaliação melhorou!"}
          subText={isFirst ? null : "Atualizar o feedback no Google?"}
          confirmText="Sim"
          cancelText="Não"
          confirmationHandle={() => {
            window.open(response.google_review_url, '_blank');
            confirmGoogleReview(Helper.getSessionToken(), response.google_review_stars).catch(() => {});
            this.refModal.current.closeModal();
            if (onDismiss) onDismiss();
          }}
          declineHandle={() => {
            this.refModal.current.closeModal();
            if (onDismiss) onDismiss();
          }}
        />
      );
      return true;
    }
    return false;
  }

  updateWorkFeedbackInPlace = (id, feedback) => {
    this._skipSignatureCheck = true;
    this.setState(prevState => {
      const updateFeedback = (work) =>
        work?.id === id ? { ...work, feedback } : work;

      const updatedCompleted = (prevState.completedWorks || []).map(updateFeedback);
      const updatedScheduleHistory = (prevState.scheduleHistoryWorks || []).map(updateFeedback);
      const updatedHistorySorted = this.mergeAndSortHistoryWorks(updatedCompleted, updatedScheduleHistory);

      return {
        completedWorks: updatedCompleted,
        scheduleHistoryWorks: updatedScheduleHistory,
        historyWorksSorted: updatedHistorySorted,
        progressWorks: (prevState.progressWorks || []).map(updateFeedback),
        scheduleWorks: (prevState.scheduleWorks || []).map(updateFeedback),
        showcaseWork: prevState.showcaseWork?.id === id
          ? { ...prevState.showcaseWork, feedback }
          : prevState.showcaseWork,
      };
    });
  }

  validateFeedback = (id, feedback) => {
    if (!this.isLiteVersion) {
      return this.sendServiceFeedback(id, feedback);
    } else {
      this.renderModal(
        <Information
          title={Labels.liteSendFeedbackTitle}
          //text={Labels.liteGenericMessage}
          confirmText={Helper.getLiteRegisterButton()}
          onClick={() => {
            Helper.callLogError('validateFeedback from isLiteVersion');
            Helper.logoutFromLite();
          }}
        />
      );
      return false;
    }
  }

  /**
   * Evento de click do serviço selecionado
   *
   * @param {number} id - id do serviço
   * @param {string} info - objecto da serviço selecionado
   */
  handlePressEvent = (id) => {
    this._isMounted = false;
    if (this.isLiteVersion) {
      const { search } = this.props.location;
      this.props.history.push(`/service-details-lite${search}`);
    } else {
      this.props.history.push(`/service-details/${id}?s=I&t=0`);
    }
  }

  getUserItems() {
    getItemList(Helper.getSessionToken()).then(value => {
      if (value && !value.code) {
        LocalData.equipmentsData = value.items;
      }
    })
  }

  getServices() {
    /**
    * Pedido para retornar dos os seriços que se encontram em curso
    *
    * @param {string} token - token de sessão
    */
    this.getInProgress();
    /**
    * Pedido para retornar os serviços concluídos que necessitam de pagamento
    */
    this.getCompletedPendingPayment();
    /**
    * Pedido para retornar dos os seriços que foram agendados
    *
    * @param {string} token - token de sessão
    */
    this.getSchedules();
    /**
    * Pedido para retornar os agendamentos histórico
    *
    * @param {string} token - token de sessão
    */
    this.getSchedulesHistory();

    /**
    * Pedido para retornar dos os seriços que já foram conlcuidos
    *
    * @param {string} token - token de sessão
    */
    this.getCompleted();
  }

  setGridState(length, service) {
    if (sessionStorage.getItem(`${service}GridState`) != null) {
      return JSON.parse(sessionStorage.getItem(`${service}GridState`));
    } else {
      return length > 0 ? true : false;
    }
  }

  getInProgress() {
    getInProgressServices(Helper.getSessionToken()).then(value => {
        if (value) {
          if (value.code) {
            this.setState({
              progressWorksState: true,
              worksLoadError: {
                ...this.state.worksLoadError,
                progress: true
              },
              loadingState: {
                ...this.state.loadingState,
                progress: false,
              },
              isLoading: false
            })
          }
          else {
            this.setState({
              progressWorks: value.works,
              progressWorksState: this.setGridState(value.works.length, 'progress'),
              worksLoadError: {
                ...this.state.worksLoadError,
                progress: false
              },
              loadingState: {
                ...this.state.loadingState,
                progress: false,
              },
              isLoading: false
            });
            LocalData.servicesData['progressWorks'] = value.works;
            if (!window.location.href.includes("asuaempresa")) {
              Helper.setCookie('prevCompanyUrl', window.location.href);
            }
          }
        }
        else {
          this.renderModal(<Information title="Pedido Sem Sucesso" text={'Foi encontrado um problema durante o pedido, por favor tente mais tarde'} onClick={() => { this.refModal.current.closeModal(); }} />);
        }
      });

    if (!LocalData.servicesData?.progressWorks) {
      return;
    }
    
    this.setState({
      progressWorks: LocalData.servicesData?.progressWorks,
      progressWorksState: this.setGridState(LocalData.servicesData?.progressWorks.length, 'progress'),
      worksLoadError: {
        ...this.state.worksLoadError,
        progress: false
      },
      loadingState: {
        ...this.state.loadingState,
        progress: false,
      },
      isLoading: false
    });
  }

  getCompletedPendingPayment() {
    getCompletedPendingPayment(Helper.getSessionToken()).then(value => {
      if (value) {
        if (value.code) {
          this.setState({
            pendingPaymentWorks: [],
          });
        } else {
          this.setState({
            pendingPaymentWorks: value.works || [],
          });
          LocalData.servicesData['pendingPaymentWorks'] = value.works || [];
        }
      } else {
        this.setState({ pendingPaymentWorks: [] });
      }
    });

    // Optimistic load from cache
    if (LocalData.servicesData?.pendingPaymentWorks) {
      this.setState({
        pendingPaymentWorks: LocalData.servicesData?.pendingPaymentWorks,
      });
    }
  }

  getSchedules() {
    getScheduleServices(Helper.getSessionToken()).then(value => {
      if (value) {
        if (value.code) {
          this.setState({
            scheduleWorksState: true,
            worksLoadError: {
              ...this.state.worksLoadError,
              schedule: true
            },
            loadingState: {
              ...this.state.loadingState,
              schedule: false,
            },
            isLoading: false
          })
        }
        else {
          this.setState({
            scheduleWorks: value.works,
            scheduleWorksState: this.setGridState(value.works.length, 'schedule'),
            worksLoadError: {
              ...this.state.worksLoadError,
              schedule: false
            },
            loadingState: {
              ...this.state.loadingState,
              schedule: false,
            },
            isLoading: false
          });
          LocalData.servicesData['scheduleWorks'] = value.works;
          if (!window.location.href.includes("asuaempresa")) {
            Helper.setCookie('prevCompanyUrl', window.location.href);
          }
        }
      }
      else {
        this.renderGenericError();
      }
    });

    if (!LocalData.servicesData?.scheduleWorks) {
      return;
    }
    
    this.setState({
      scheduleWorks: LocalData.servicesData?.scheduleWorks,
      scheduleWorksState: this.setGridState(LocalData.servicesData?.scheduleWorks.length, 'progress'),
      worksLoadError: {
        ...this.state.worksLoadError,
        schedule: false
      },
      loadingState: {
        ...this.state.loadingState,
        schedule: false,
      },
      isLoading: false
    });
  }

  getSchedulesHistory() {
    // Optimistic state update from cached data, if available
    if (LocalData.servicesData?.scheduleHistoryWorks) {
      this.setState({
        scheduleHistoryWorks: LocalData.servicesData?.scheduleHistoryWorks,
        scheduleHistoryWorksState: this.setGridState(LocalData.servicesData?.scheduleHistoryWorks.length, 'scheduleHistory'),
        historyWorksSorted: this.mergeAndSortHistoryWorks(this.state.completedWorks, LocalData.servicesData?.scheduleHistoryWorks),
        worksLoadError: {
          ...this.state.worksLoadError,
          scheduleHistory: false,
          historyWorks: false
        },
        loadingState: {
          ...this.state.loadingState,
          scheduleHistory: false,
          historyWorks: false
        },
        isLoading: false
      });
    }

    return getScheduleHistoryServices(Helper.getSessionToken()).then(value => {
      if (value) {
        if (value.code) {
          this.setState({
            scheduleHistoryWorksState: true,
            worksLoadError: {
              ...this.state.worksLoadError,
              scheduleHistory: true
            },
            loadingState: {
              ...this.state.loadingState,
              scheduleHistory: false,
            },
            isLoading: false
          });
        }
        else {
          value.works.forEach(work => { work.isAppointment = true; });
          LocalData.servicesData['scheduleHistoryWorks'] = value.works;
          // Merge and sort history works after update
          const mergedSorted = this.mergeAndSortHistoryWorks(this.state.completedWorks, value.works);
          this.setState({
            scheduleHistoryWorks: value.works,
            scheduleHistoryWorksState: this.setGridState(value.works.length, 'scheduleHistory'),
            historyWorksSorted: mergedSorted,
            worksLoadError: {
              ...this.state.worksLoadError,
              scheduleHistory: false,
              historyWorks: false
            },
            loadingState: {
              ...this.state.loadingState,
              scheduleHistory: false,
              historyWorks: false
            },
            isLoading: false
          });
          if (!window.location.href.includes("asuaempresa")) {
            Helper.setCookie('prevCompanyUrl', window.location.href);
          }
        }
      }
      else {
        this.renderGenericError();
      }
    }).catch(() => {
      // Swallow errors to continue flow
      return null;
    });
  }

  getCompleted() {
    // Optimistic state update from cached data, if available
    if (LocalData.servicesData?.completedWorks) {
      this.setState({
        completedWorks: LocalData.servicesData?.completedWorks,
        completedWorksState: this.setGridState(LocalData.servicesData?.completedWorks.length, 'completed'),
        historyWorksSorted: this.mergeAndSortHistoryWorks(LocalData.servicesData?.completedWorks, this.state.scheduleHistoryWorks),
        worksLoadError: {
          ...this.state.worksLoadError,
          completed: false,
          historyWorks: false
        },
        loadingState: {
          ...this.state.loadingState,
          completed: false,
          historyWorks: false
        },
        isLoading: false
      });
    }

    return getCompletedServices(Helper.getSessionToken()).then(value => {
      if (value) {
        if (value.code) {
          this.setState({
            completedWorksState: true,
            worksLoadError: {
            ...this.state.worksLoadError,
            completed: true
            },
            loadingState: {
              ...this.state.loadingState,
              completed: false,
            },
            isLoading: false
          });
        }
        else {
          LocalData.servicesData['completedWorks'] = value.works;
          // Merge and sort history works after update
          const mergedSorted = this.mergeAndSortHistoryWorks(value.works, this.state.scheduleHistoryWorks);
          this.setState({
            completedWorks: value.works,
            completedWorksState: this.setGridState(value.works.length, 'completed'),
            historyWorksSorted: mergedSorted,
            worksLoadError: {
              ...this.state.worksLoadError,
              completed: false,
              historyWorks: false
            },
            loadingState: {
              ...this.state.loadingState,
              completed: false,
              historyWorks: false
            },
            isLoading: false
          });
          if (!window.location.href.includes("asuaempresa")) {
            Helper.setCookie('prevCompanyUrl', window.location.href);
          }
        }
      }
      else {
        this.renderGenericError();
      }
    }).catch(() => {
      // Swallow errors to continue flow
      return null;
    });
  }

  gridState(length) {
    return length > 0;
  }

  handlerTopUpButton = (event) => {
    event.stopPropagation();
    if (this.listScroll) {
      this.listElement.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (this.winScroll) {
      this.mobileElement.scrollTo({ top: 0, behavior: 'smooth'});
    }
  }

  renderShowcaseContainer = (work, isAppointment) => {
    if (!work || !this.isLiteVersion) { return; }
    const { isMobile } = this.state;
    const companyName = Helper.companyName();
    return (
      <Fragment>
        {isMobile && <div style={{height: "24px"}}></div>}
        <CardService
          data={work}
          isAppointment={isAppointment}
          isLiteVersion={true}
          onClick={() => this.handlePressEvent(this.token, work)}
          callback={(id, rating) => this.validateFeedback(id, rating)}
        />

        {(!isMobile && isAppointment) && this.renderAddNewAppointmentButton(companyName)}
      </Fragment>
    );
  }

  handleEventVideoTutorial = () => {
    this.renderModal(
      <VideoTutorial
        title={"Tutorial Cliente"}
        onClick={() => {
          this.refModal.current.closeModal();
        }}
        videoId="ZgPUE68tg-U" // Replace with your YouTube video ID
      />,
      false,
      true
    );
  };

  renderLiteMessage = (gridId) => {
    const loggedIn = Helper.getSessionToken();
    const renderCTAappStore = () => {
      const isLite = Helper.isLiteVersion();

      const gap = 18; // consistent spacing
      const commonImgStyle = { maxWidth: 180, width: '100%', height: 'auto', display: 'block' };
      const playBtn = (
        <a
          key="play"
          href={Helper.linkToAppStore()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block' }}
        >
          <img
            src={GENERAL.callPlayStoreButton}
            alt="Instalar pela Play Store"
            style={commonImgStyle}
          />
        </a>
      );
      const appBtn = (
        <a
          key="app"
          href={Helper.linkToAppStore()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'inline-block' }}
        >
          <img
            src={GENERAL.callAppStoreButton}
            alt="Instalar pela App Store"
            style={commonImgStyle}
          />
        </a>
      );

      let buttons = [];
      if (Helper.isAndroidBrowser() && isLite) {
        buttons = [playBtn];
      } else if (Helper.isIOSBrowser() && isLite) {
        buttons = [appBtn];
      } else if (isLite) { // unknown platform + lite mode => show both
        buttons = [playBtn, appBtn];
      } else {
        // Non-lite & unknown platform: no buttons (spec not defined) -> return null
        return null;
      }

      const isBoth = buttons.length === 2;
      return (
        <>
          <div
            className='appstore-buttons-container'
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: isBoth ? gap : 0,
              padding: isBoth ? `0 12px` : 0,
              maxWidth: '330px',
              margin: 'auto',
            }}
          >
            {buttons}
          </div>
        </>
      );
    };

    return (
      <React.Fragment>
        {loggedIn &&
          <>
            <div className={`d-none d-md-flex flex-column justify-content-center mt-4`}>
              <Button className="cta-button-primary d-medium mediumWidth" 
                type="button"
                value={"Voltar à minha conta"} onClick={() => window.location.href = `${process.env.PUBLIC_URL}`} />
            </div>
            <div className={`d-flex flex-column d-md-none justify-content-center mt-4`}>
              <Button className="cta-button-primary d-medium" type="button"
                value={"Voltar à minha conta"} onClick={() => window.location.href = `${process.env.PUBLIC_URL}`} />
            </div>
          </>
        }
        <ConfirmationCTA
          confirmText={Helper.getLiteRegisterButton(loggedIn)}
          confirmationHandle={() => {
            Helper.callLogError('ConfirmationCTA from LiteMessage');
            Helper.logoutFromLite();
          }}
          declineHandle={() => Emitter.emit('LIST_GRID_STATE_CHANGED', gridId)}
        />
        <div className='mt-4'>
          <button className='link-container showcase-message p-1'
            onClick={this.handleEventVideoTutorial}
            style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
          >
            <img
              src={SIDEBAR.videoDemoIcon}
              alt="Vídeo Demo Icon"
              className='showcase-icon'
              style={{ filter: 'brightness(0) saturate(100%) invert(55%) sepia(52%) saturate(7052%) hue-rotate(175deg) brightness(99%) contrast(100%)' }}
            />
            Vídeo de Demonstração
          </button>
        </div>
        <div className='mt-4'/>
        {renderCTAappStore()}
        <p className='mt-10'>{Labels.liteGenericMessage(LocalData.configData?.is_scheduler_solo)}</p>
      </React.Fragment>
    );
  }

  renderLiteMessageContainer = (title, gridId) => {
    const isLargeScreen = typeof window !== 'undefined' ? window.innerWidth > 992 : false;
    const containerClass = `welcome-message-container ${isLargeScreen ? ' mt-0' : 'mt-4'}`;
    return (
      <div className={containerClass}>
        <div className="ask-container">
          <div className="ask">
            <h3> {title}</h3>
            <div className="pt-3"></div>
            {this.renderLiteMessage(gridId)}
            
          </div>
        </div>
      </div>
    );
  }

  renderAddNewAppointmentButton = (companyName) => {
    const { isMobile } = this.state;
    const className = classNames("cta-bottom-container d-flex justify-content-center flex-column", {"mt-4 mb-1": !isMobile, "mb-4": isMobile});
    const schedulerLabel = `${Labels.schedulers.newscheduler} ${companyName}`;

    return (
      <div className={className}>
        <div
          className="cta-button-primary d-flex d-inline-flex px-3 justify-content-center align-items-center"
          role="button"
          onClick={() => {
            if (LocalData.configData?.scheduler_module !== "FULL") {          
              Emitter.emit("SIDEBAR_OPEN", "btnScheduleShowMyEquipments");
            } else {
            if(this.isLiteVersion) {
                const { search } = this.props.location;
                this.props.history.push(`/schedule-lite${search}`);
              } else {
                this.props.history.push(`/schedule`);
              }
            }
          }}
        >
          <span className="text-multiline-truncate" style={{ fontSize: "16px" }}>{schedulerLabel}</span>
        </div>

        <div className="link-container mt-2 text-center">
          {!Helper.isLiteVersion() && (
            <span
              style={{ fontSize: '14px' }}
              onClick={() => {
                Emitter.emit("SIDEBAR_OPEN", "btnScheduleOldAppointments");
              }}
            >
              {Labels.sidebarScheduleMessage().oldAppointmentsLink}
            </span>
          )}
        </div>
      </div>
    );
  }

  renderScheduleList = () => {
    const { scheduleWorks, showcaseWork, worksLoadError, isMobile } = this.state;
    const companyName = Helper.companyName().replace(/ /g, '\u00A0');
    const schedulerLabel = `${Labels.schedulers.newscheduler} ${companyName}`;

    if (this.isLiteVersion) {
      const isAppointment=true;
      if (showcaseWork?.state?.bars === 0  && showcaseWork?.is_history === false) {
        return this.renderShowcaseContainer(showcaseWork, isAppointment);
      } 
    }

    if (worksLoadError.schedule) {
      return (
        <div className="empty-services-container" style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: Labels.errorLoadServices}}>
        </div>
      );
    }

    if (Helper.listIsEmpty(scheduleWorks)) {
      return (isMobile 
        ? <div className="counter-message-list-mobile-nocounter">{Labels.counterMessages.noschedulers.replace(Labels.counterMessages.companyname, companyName)}</div>
        : <>
            <div className="empty-services-container">{Labels.counterMessages.noschedulers.replace(Labels.counterMessages.companyname, companyName)}</div>
            <div className="cta-bottom-container d-flex justify-content-center flex-column">
              <div
                className="cta-button-primary d-flex d-inline-flex px-3 justify-content-center align-items-center"
                role="button"
                onClick={() => { 
                  if (LocalData.configData?.scheduler_module !== "FULL") {       
                    Emitter.emit("SIDEBAR_OPEN", "btnScheduleShowMyEquipments");
                  } else {
                    if(this.isLiteVersion) {
                      const { search } = this.props.location;
                      this.props.history.push(`/schedule-lite${search}`);
                    } else {
                      this.props.history.push(`/schedule`);
                    }
                  }
                }}
              >
                <span className="text-multiline-truncate" style={{ fontSize: "16px" }}>{schedulerLabel}</span>
              </div>
              <div className="link-container mt-2 text-center">
                <span                  
                  style={{ fontSize: '14px' }}
                  onClick={() => { Emitter.emit('SIDEBAR_OPEN', 'btnScheduleOldAppointments'); }}>
                  {" "}
                  {Labels.sidebarScheduleMessage().oldAppointmentsLink}
                </span>
              </div>
            </div>
        </>
      );
    }

    return (
      <>
        {isMobile && <div style={{ height: "24px" }}></div>}
        {scheduleWorks.map((prop, index) => {
          const isAppointment = true;
          return (
            <CardService key={prop.id || index} data={prop} isAppointment={isAppointment} type="schedule"
              onClick={() => this.handlePressEvent(prop.id, prop)}
            />
          );
        })
        }

        {isMobile && <div style={{ height: "90px" }}></div>}

        {!isMobile && this.renderAddNewAppointmentButton(companyName)
        }
      </>)
  }

  renderProgressList = () => {
    const { progressWorks, pendingPaymentWorks, showcaseWork, worksLoadError, isMobile } = this.state;
    const companyName = Helper.companyName();
    // Merge active works with pending-payment works
    const mergedWorks = [...(progressWorks || []), ...(pendingPaymentWorks || [])];

    if (this.isLiteVersion) {
      const title = Labels.liteProgressTitle;
      if (showcaseWork?.state?.bars > 0 && showcaseWork.state?.bars < 5) {
        return this.renderShowcaseContainer(showcaseWork);
      } else {
        return this.renderLiteMessageContainer(title, 'progress');
      }
    }
    if (worksLoadError.progress) {
      return (
        <div className="empty-services-container" style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: Labels.errorLoadServices}}>
        </div>
      );
    }

    if (Helper.listIsEmpty(mergedWorks)) {
      const noProgressMessage = LocalData.configData?.is_scheduler_solo ? Labels.counterMessages.noservicesScheduler : Labels.counterMessages.noservices.replace(Labels.counterMessages.companyname, companyName);
      return (isMobile 
        ? <div className="counter-message-list-mobile-nocounter">{noProgressMessage}</div>
        : <div className="empty-services-container">{noProgressMessage}</div>
      );
    }

    return (
      <div className="h-100">
        {isMobile && <div style={{height: "24px"}}></div>}
    {mergedWorks.map((prop, index) => {
          return (
            <CardService
      key={prop.id || index}
              data={prop}
              onClick={() => this.handlePressEvent(prop.id, prop)}
              callback={this.validateFeedback}
            />
          );
        })}
      </div>
    );
  }

  renderHistoryList = () => {
    let { showcaseWork, historyWorksSorted, completedWorks, worksLoadError, isMobile } = this.state;
    const is_scheduler_solo = LocalData.configData?.is_scheduler_solo;

    const countToFeedbackServices = is_scheduler_solo ? 
                                    Helper.countToFeedbackServices(historyWorksSorted, showcaseWork) :
                                    Helper.countToFeedbackServices(completedWorks, showcaseWork);
    const companyName = Helper.companyName();
    const pluralSuffix = countToFeedbackServices > 1 ? 's' : '';

    if (this.isLiteVersion) {
      const title = Labels.liteHistoryTitle;
      if (showcaseWork?.state?.bars === 5) {
        return this.renderShowcaseContainer(showcaseWork);
      }
      if (showcaseWork?.state?.bars === 0 && showcaseWork?.is_history === true) {
        const isAppointment = true;
        return this.renderShowcaseContainer(showcaseWork, isAppointment);
      }
      return this.renderLiteMessageContainer(title, 'completed');
    }

    if (worksLoadError.completed) {
      return (
        <div className="empty-services-container" style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: Labels.errorLoadServices}}>
        </div>
      );
    }

    if (Helper.listIsEmpty(historyWorksSorted)) {
      return (isMobile 
        ? <div className="counter-message-list-mobile-nocounter">{Labels.counterMessages.noservicesclassification.replace(Labels.counterMessages.companyname, companyName)}</div> 
        : <div className="empty-services-container">{Labels.counterMessages.noservicesclassification.replace(Labels.counterMessages.companyname, companyName)}</div>
      );
    }

    const message = Labels.counterMessages.classification
      .replace(Labels.counterMessages.companyname, companyName)
      .replace(/{{plural}}/g, pluralSuffix);
    const useVirtual = isMobile && historyWorksSorted.length > 40; // only virtualize when big and mobile
    return (
      <>
        {isMobile
          ? countToFeedbackServices
            ? <div className="counter-message-list-mobile">{countToFeedbackServices} {message}</div>
            : ''
          : <div className="counter-message-list-desktop" />
        }
        {isMobile && !countToFeedbackServices && <div style={{ height: "24px" }}></div>}

        {useVirtual ? (
          <React.Suspense fallback={null}>
            {(() => {
              const WindowedList = require('components/list/WindowedList.jsx').default;
              return (
                <WindowedList
                  items={historyWorksSorted}
                  itemHeight={280}
                  overscan={1}
                  useWindowScroll={true}
                  containerId={'scroll-container'}
                  minColumnWidth={324}
                  gap={0}
                  renderItem={(prop, index) => (
                    <CardService
                      key={prop.id || index}
                      data={prop}
                      isAppointment={prop.isAppointment}
                      containerStyle={{ marginBottom: 0 }}
                      onClick={() => this.handlePressEvent(prop.id, prop)}
                      callback={(id, rating) => this.validateFeedback(id, rating)}
                    />
                  )}
                />
              );
            })()}
          </React.Suspense>
        ) : (
          historyWorksSorted.map((prop, index) => (
            <CardService
              key={prop.id || index}
              data={prop}
              isAppointment={prop.isAppointment}
              onClick={() => this.handlePressEvent(prop.id, prop)}
              callback={(id, rating) => this.validateFeedback(id, rating)}
            />
          ))
        )}
      </>
    );
  }

  renderNoServicesMessage = () => {
    return (
      <div className="no-services-message-container align-center justify-content-center m-3 p-3 m-lg-5 p-lg-5">
        <p> {Labels.noServicesMessage(Helper.companyName())}</p>
      </div>
    );
  }

  goToSlide = (slide) => {
    if (this.swiperInstance) {
      this.swiperInstance.slideTo(slide);
    }
  };

  renderServicesList = () => {
    if (!LocalData.terms_accepted && !Helper.isLiteVersion() && !Helper.isDemo()) return null;
    const { progressWorks, pendingPaymentWorks, scheduleWorks, historyWorksSorted, completedWorks, showcaseWork,
      progressWorksState, scheduleWorksState, scheduleHistoryWorksState, completedWorksState, isMobile, swiperLoaded, loadingState: { progress, schedule, historyWorks } } = this.state;
    const isLoading = !Helper.isLiteVersion() ? (progress || schedule || historyWorks) && !LocalData.servicesLoaded : this.state.isLoading && !this.isLiteWithoutToken;
    const mergedProgressWorks = [...(progressWorks || []), ...(pendingPaymentWorks || [])];
    const hasNoServices = Helper.hasNoServices([mergedProgressWorks, scheduleWorks, historyWorksSorted], showcaseWork);
    const countProgressServices = Helper.countProgressServices(progressWorks, showcaseWork) + (pendingPaymentWorks?.length || 0);
    const countScheduleServices = Helper.countScheduleServices(scheduleWorks, showcaseWork);
    const is_scheduler_solo = LocalData.configData?.is_scheduler_solo;

    const countToFeedbackServices = is_scheduler_solo ? 
                                Helper.countToFeedbackServices(historyWorksSorted, showcaseWork) :
                                Helper.countToFeedbackServices(completedWorks, showcaseWork);

    if (isLoading) {
      return;
    }

    if (hasNoServices) {
      setTimeout(() => {
        return this.renderNoServicesMessage();
      }, 100);
    }
    if (isMobile && !swiperLoaded && !isLoading) {
      setTimeout(() => {
        this.setState({swiperLoaded: true});
        BVService.swiperLoaded = true;
      }, 500);
    }
    
    if (isMobile && swiperLoaded && !isLoading) {
      let initialSlide = !Helper.isLiteVersion()
        ? BVService.getInitialSlide(mergedProgressWorks, scheduleWorks, historyWorksSorted)
        : BVService.getInitialLiteSlide(
            progressWorksState,
            scheduleWorksState,
            historyWorksSorted
          );
      BVService.setSwiperSlide(initialSlide);
      const onSwiper = (swiper) => {
        this.swiperInstance = swiper;
      }

  return (
        <div className="swiper-services-container mt-2" id="swiper-services-container">
          <div className="swiper-tabs-container row m-0 g-0" role="button" id="swiper-tabs-services">
            <div className="swiper-tab col-4 pb-2" onClick={() => this.goToSlide(0)}>
              {Labels.swiper.slide1}
              {countProgressServices && countProgressServices > 0 ? <div className="swiper-title-counter"> ({countProgressServices})</div> : null}
              {countProgressServices && countProgressServices > 0 ? <div className="swiper-title-counter-alert" /> : null}
            </div>
            <div className="swiper-tab col-4 pb-2" onClick={() => this.goToSlide(1)}>
              {Labels.swiper.slide2}
              {countScheduleServices && countScheduleServices > 0 ? <div className="swiper-title-counter"> ({countScheduleServices})</div> : null}              
              {countScheduleServices && countScheduleServices > 0 ? <div className="swiper-title-counter-alert" /> : null}
            </div>
            <div className="swiper-tab col-4 pb-2" onClick={() => this.goToSlide(2)}>
              {Labels.swiper.slide3}
              {countToFeedbackServices && countToFeedbackServices > 0 ? <div className="swiper-title-counter"> ({countToFeedbackServices})</div> : null}
              {countToFeedbackServices && countToFeedbackServices > 0 ? <div className="swiper-title-counter-alert" /> : null}
            </div>
          </div>
          <Swiper
            initialSlide={initialSlide}
            slidesPerView={1}
            onSlideChange={(slide) => {
              BVService.setSwiperSlide(slide?.activeIndex);
              const winScroll = this.state.firstTimeSwiperLoading ? BVService.getScrollPos(slide?.activeIndex) : 0;
              this.setState({
                currentSlide: slide?.activeIndex,
                firstTimeSwiperLoading: false,
              });
              setTimeout(() => {
                this.scrollTo(winScroll);
              }, 300);
            }}
            onSwiper={onSwiper}
            scrollbar={{
              hide: false,
              draggable: true,
            }}
            modules={[Scrollbar]}
            autoHeight={true}
            touchRatio={1}
            longSwipesRatio={0}
            speed={80}
            resistance={false}
            touchAngle={30}
            zoom={false}
            // threshold={1}
            // followFinger={false}
            // freeMode={true}
            // cssMode={false}
          >
            <SwiperSlide>
              {this.renderProgressList()}
            </SwiperSlide>
            <SwiperSlide>
              {this.renderScheduleList()}
            </SwiperSlide>
            <SwiperSlide>
              {this.renderHistoryList()}
            </SwiperSlide>
            {/* ... additional slides */}
          </Swiper>
        </div>
      );
    }

    return isMobile || isLoading ? null : (
      <React.Fragment>
        <Grid title="Em Curso" status={progressWorksState} type="progress" counterAlert={countProgressServices} styleClass="mt-3">
          {this.renderProgressList()}
        </Grid>
        <Grid title="Marcações" status={scheduleWorksState} type="schedule" counterAlert={countScheduleServices}>
          {this.renderScheduleList()}
        </Grid> 
        <Grid title="Histórico" status={completedWorksState || scheduleHistoryWorksState} type="completed" counterAlert={countToFeedbackServices}>
          {this.renderHistoryList()}
        </Grid>
      </React.Fragment>
    );
  }

  renderMobileTabs = () => {

  };

  renderLoader = () => {
    const { loadingState: { progress, schedule, historyWorks } } = this.state;
    const isLoading = !Helper.isLiteVersion() ? (progress || schedule || historyWorks) && LocalData.terms_accepted : this.state.isLoading;

    if (isLoading && !this.isLiteWithoutToken && !LocalData.servicesLoaded) {
      return (
        <Loader
          message=""
          local={true}
          big={true}
          inverted={true}
          height={"250px"}
        ></Loader>
      );
    } else {
      LocalData.servicesLoaded = true;
    }

    return;
  }

  renderGenericError = () => {
    this.renderInfoModal(Labels.genericErrorTitle, Labels.genericErrorMessage);
  }

  renderInfoModal = (title, message) => {
    this.renderModal(
      <Information
        title={title}
        text={message}
        onClick={() => this.refModal.current.closeModal()}/>
    );
  }

  renderModal = (view, isMedia = false, occupyScreen=false) => {
    this.refModal.current.renderView(view, isMedia, occupyScreen);
    this.refModal.current.openModal();
  }

  /**
   * Render da view
   */
  render() {
    const { isLoading, swiperLoaded, currentSlide, isMobile } = this.state;
    const companyName = Helper.companyName();

    return (
      <>
        <IAgreeBox url={window.location} />
        <div
          className="main-container overflow-hidden-mobile"
          id="main-container"
          key={this.state.dataVersion}
        >
          <div
            className="list-view-container overflow-hidden-mobile"
            id="scroll-container"
            ref={this.listviewRef}
          >
            {this.renderLoader()}
            {this.renderServicesList()}
          </div>

          {isMobile && swiperLoaded && !isLoading && currentSlide === 1 && (
            <div className="container-main-footer-button">
              {this.renderAddNewAppointmentButton(companyName)}
            </div>
          )}

          <Modal ref={this.refModal} />
          <Helmet>
            {" "}
            <title> {Helper.titleServicesPage()} </title>{" "}
          </Helmet>
        </div>
      </>
    );
  }
}

export default withRouter(Home);


